import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import SingleNote from './single_note';
import './note_list.scss';

class NoteList extends Component {
  constructor(props) {
    super(props);
    this.toggleShow = this.toggleShow.bind(this);
    this.state = { allShown: this.props.maxStart === 0 };
  }

  toggleShow() {
    this.setState({ allShown: !this.state.allShown });
  }

  renderDisplayLink() {
    const { notes, maxStart } = this.props;

    if (notes.length > maxStart) {
      return this.state.allShown ? (
        <Button color="link" className="p-0" onClick={this.toggleShow}>
          Show Less
        </Button>
      ) : (
        <Button color="link" className="p-0" onClick={this.toggleShow}>
          Show All Notes
        </Button>
      );
    }
    return null;
  }

  render() {
    const { notes, maxStart } = this.props;

    const notesToShow = this.state.allShown ? notes : notes.slice(0, maxStart);
    return (
      <div className="note-list">
        {notesToShow.map(note => (
          <SingleNote note={note} key={note.id} />
        ))}

        {this.renderDisplayLink()}
      </div>
    );
  }
}

NoteList.propTypes = {
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      note: PropTypes.string,
      id: PropTypes.number,
    }),
  ),
  maxStart: PropTypes.number, // specify 0 to show all by default.
};

NoteList.defaultProps = {
  maxStart: 3,
};

export default NoteList;
